<template>
  <tbody class="is-editable">
    <tr>
      <!-- <td class="c-table__cell--center c-table__cell--middle u-w100">{{ message.message_group_message ? message.message_group_message.message_group.group_name : '-' }}</td> -->
      <td v-if="displayItems.messageId" class="c-table__cell--middle c-table__cell--center">
        <p class="u-text-ellipsis">
          {{ message.message_id }}
        </p>
      </td>
      <td v-if="displayItems.messageName" class="c-table__cell--middle">
        <p class="u-text-ellipsis message-name">
          {{ message.message_name }}
        </p>
      </td>
      <td v-if="displayItems.messageTitle" class="c-table__cell--middle">
        <p class="u-text-bold u-text-ellipsis">
          <span>{{ message.message_title }}</span>
        </p>
        <br />
        <p class="u-text-ellipsis">
          <span>{{ message.message_text }}</span>
        </p>
      </td>
      <td v-if="displayItems.deliverType" class="c-table__cell--center c-table__cell--middle">
        {{ messageInfo.deliverTypes[message.message_deliver.deliver_type] }}
      </td>
      <td v-if="displayItems.deliveryDateFrom" class="c-table__cell--middle">
        {{ getDisplayDate(message.message_deliver.send_start_date) }}<br />{{ getDisplayTime(message.message_deliver.send_start_date) }}
      </td>
      <td v-if="displayItems.deliveryDateTo" class="c-table__cell--middle">
        {{ getDisplayDate(message.message_deliver.send_end_date) }}<br />{{ getDisplayTime(message.message_deliver.send_end_date) }}
      </td>
      <td v-if="displayItems.deliverStatus" class="c-table__cell--middle c-table__cell--center">
        {{ getDisplayStatus }}
      </td>
      <td class="c-table__cell--middle c-table__cell--center">
        <p>{{ messageInfo.serviceTypes[message.service_type] }}</p>

        <div class="c-table-editable">
          <ul class="c-table-editable-list">
            <li v-if="showStopIcon" class="c-table-editable-list__item">
              <a class="c-btn c-btn--white c-btn--circle" @click="onStopClick">
                <div class="c-btn__text c-btn__text--balloon">停止する</div>
                <div class="c-icon c-icon--gray-3 u-wh20" style="width: 27px !important; height: 27px !important;"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <use xlink:href="/assets/img/sprite.svg#stop" />
                </svg>
                </div>
              </a>
            </li>
            <li v-if="showEditIcon" class="c-table-editable-list__item">
              <a class="c-btn c-btn--white c-btn--circle" href="#edit" @click="onEditClick">
                <div class="c-btn__text c-btn__text--balloon">編集する</div>
                <div class="c-icon c-icon--gray-3 u-wh20">
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <use xlink:href="/assets/img/sprite.svg#edit" />
                  </svg>
                </div>
              </a>
            </li>
            <li v-if="showReviewIcon" class="c-table-editable-list__item">
              <a class="c-btn c-btn--white c-btn--circle" @click="onReviewClick">
                <div class="c-btn__text c-btn__text--balloon">確認する</div>
                <div class="c-icon c-icon--gray-3 u-wh20">
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <use xlink:href="/assets/img/sprite.svg#review" />
                  </svg>
                </div>
              </a>
            </li>
            <li v-if="showCloneIcon" class="c-table-editable-list__item">
              <a class="c-btn c-btn--white c-btn--circle" href="#trash" @click="onCopyClick">
                <div class="c-btn__text c-btn__text--balloon">複製する</div>
                <div class="c-icon c-icon--gray-3 u-wh20">
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <use xlink:href="/assets/img/sprite.svg#clone" />
                  </svg>
                </div>
              </a>
            </li>
            <li class="c-table-editable-list__item">
              <a class="c-btn c-btn--white c-btn--circle" href="#trash" @click="onDeleteClick">
                <div class="c-btn__text c-btn__text--balloon">削除する</div>
                <div class="c-icon c-icon--gray-3 u-wh20">
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <use xlink:href="/assets/img/sprite.svg#trash" />
                  </svg>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </td>
    </tr>
  </tbody>
</template>

<script>
export default {
  props: {
    message: Object,
    messageInfo: Object,
    displayItems: Object,
  },
  emits: ["delete-click","stop-click","copy-click","edit-click","review-click"],
  computed: {
    getDisplayStatus: function () {
      return this.message.deliver_status == 30 &&
        this.message.service_type == 4
        ? '配信中'
        : this.messageInfo.deliverStatus[this.message.deliver_status];
    },
    showStopIcon: function () {
      return (
        this.message.deliver_status == 10 ||
        this.message.deliver_status == 20 ||
        (this.message.deliver_status == 30 &&
          this.message.service_type == 4)
      );
    },
    showEditIcon: function () {
      if (this.message.scenario_id || this.message.abtest_id) {
        return false;
      }
      return (
        this.message.deliver_status != 30 ||
        this.message.service_type == 1 ||
        this.message.service_type == 4
      );
    },
    showReviewIcon: function () {
      return (
        this.message.deliver_status == 30 &&
        this.message.service_type != 1 &&
        this.message.service_type != 4
      );
    },
    showCloneIcon: function () {
      return !this.message.scenario_id && !this.message.abtest_id;
    },
  },
  methods: {
    onDeleteClick: function () {
      this.$emit('delete-click',this.message);
    },
    onStopClick: function () {
      this.$emit('stop-click', this.message);
    },
    onCopyClick: function () {
      this.$emit('copy-click',this.message);
    },
    onEditClick: function () {
      this.$emit('edit-click',this.message);
    },
    onReviewClick: function () {
      this.$emit('review-click',this.message);
    },
  }
};
</script>

<style>
/* body .l-main {
    width: 1280px;
} */
.p-message-result__data .c-table tbody tr td {
    font-size: 14px;
}
.u-text-ellipsis {
  width: 100%;
  display: inline-block; /* important */
  white-space: nowrap;
  overflow: hidden;
}

.u-text-ellipsis:not(:hover) {
  text-overflow: ellipsis;
}

.u-text-ellipsis:hover span,
.u-text-ellipsis:focus span {
  display: inline-block;
  animation-name: scroll-text;
  animation-duration: 7s;
  animation-timing-function: linear;
  animation-delay: 0s;
  animation-iteration-count: infinite;
  animation-direction: normal;
}

.message-name {
    word-wrap: break-word;
    white-space: normal;
}

@keyframes scroll-text {
  0% {
    transform: translateX(0%);
  }
  90% {
    transform: translateX(-100%);
  }
  95% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(0%);
  }
}

</style>
